export const PUBLIC_FEEDS_KEY = 'feeds-public'

const isPublicFeeds = (key: string) => key === PUBLIC_FEEDS_KEY

export default isPublicFeeds
